module.exports = __webpack_public_path__ + "img/ipfs_active.176e7a84.svg";